import getStringDateAndHourFromDate from '../../../localUtils/getStringDateAndHourFromDate'

export default function getLastMonthAgo() {
  const today = new Date()
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)

  const stringToday = getStringDateAndHourFromDate(today)
  const stringFirstDayOfMonth = getStringDateAndHourFromDate(firstDayOfMonth)

  const options = {
    name: 'LAST_MONTH',
    label: 'Ultimo mês',
    startDate: stringFirstDayOfMonth.date,
    finalDate: stringToday.date,
    startHour: '00:00',
    finalHour: '23:59',
  }

  return options
}
